var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-modal',{attrs:{"title":"Callback Info","hide-footer":""},on:{"hide":function($event){return _vm.$emit('update:is-show', false)}},model:{value:(_vm.showInfoModal),callback:function ($$v) {_vm.showInfoModal=$$v},expression:"showInfoModal"}},[_c('div',[_vm._v(" Will be added like: &event_callback_{token}= ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }